import { Button } from "@heroui/react";
import { LimeInput } from "./LimeInput";
import { t } from "@lingui/core/macro";
import { api } from "@/lib/api-client";
import { GetLookupCompanyData } from "@/server-types";
import { ScanSearch } from "lucide-react";
import { cn } from "@/utils";

export const CompanyLookupInput = ({
  label,
  taxNumber,
  onValueChange,
  onLookupSuccess,
  error,
}: {
  label?: string;
  taxNumber: string;
  onValueChange: (taxNumber: string) => void;
  onLookupSuccess: (companyData: GetLookupCompanyData["response"]) => void;
  error?: string | React.ReactNode;
}) => {
  const {
    mutateAsync: getLookupCompanyData,
    isPending: isFetchingCompanyData,
    processedErrorMessage: getLookupCompanyDataErrorMessage,
  } = api.external.useGetLookupCompanyData();

  return (
    <LimeInput
      label={label ?? t`Davčna številka podjetja`}
      variant="bordered"
      value={taxNumber}
      onValueChange={onValueChange}
      data-identifier="company-tax-number"
      error={error}
      endContent={
        <Button
          isIconOnly
          variant="bordered"
          className={cn("h-full", {
            "border-danger text-danger":
              error != null || getLookupCompanyDataErrorMessage != null,
          })}
          type="button"
          onPress={async () => {
            const companyData = await getLookupCompanyData(taxNumber);
            onLookupSuccess(companyData);
          }}
          isDisabled={taxNumber.length === 0}
          isLoading={isFetchingCompanyData}
        >
          <ScanSearch />
        </Button>
      }
    />
  );
};
